import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  BoxComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';
import type { IconName } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-selection-item',
  templateUrl: './evaluation-selection-item.component.html',
  styleUrls: ['./evaluation-selection-item.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    HeadingComponent,
    IconComponent,
    RtTooltip,
    TranslatePipe,
    TruncateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(mouseenter)': 'isHovered.set(true)',
    '(mouseleave)': 'isHovered.set(false)',
  },
})
export class EvaluationSelectionItemComponent {
  public readonly icon = input<IconName>(undefined!);
  public readonly heading = input<string>('');
  public readonly subheading = input<string>('');
  public readonly recommended = input(false);
  public readonly truncateHeading = input(false);

  protected isHovered = signal(false);
}
